<template>
  <div class="videoControls" style="display: flex; align-items: center">
    <div class="userIsMuted">
      <IconBase icon-name="mic" :iconColor="partnerAudio || partnerAudio === null ? '#2c2c2d' : '#a72143'" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"
        ><component :is="micIcon"
      /></IconBase>
    </div>
    <div class="userIsMuted cam">
      <IconBase
        icon-name="mic"
        :iconColor="partnerVideo || partnerVideo === null ? '#2c2c2d' : '#a72143'"
        :viewBox="partnerVideo || partnerVideo === null ? '0 0 455.168 455.168' : '0 0 460.8 460.8'"
        width="100%"
        height="100%"
        strokeWidth="0px"
        ><component :is="camIcon"
      /></IconBase>
    </div>
  </div>
</template>

<script>
import IconBase from "../../../../components/IconBase";
import IconMicOn from "../../../../components/SVG/MediaIndicators/IconMicOn";
import IconMicOff from "../../../../components/SVG/MediaIndicators/IconMicOff";
import IconCamOn from "../../../../components/SVG/MediaIndicators/IconCamOn";
import IconCamOff from "../../../../components/SVG/MediaIndicators/IconCamOff";

export default {
  name: "RemoteVideoIndicators",
  props: {
    partnerAudio: Boolean,
    partnerVideo: Boolean,
    partnerScreen: Boolean,
  },
  components: {
    IconBase,
    IconMicOn,
    IconMicOff,
    IconCamOn,
    IconCamOff,
  },
  computed: {
    micIcon() {
      return this.partnerAudio || this.partnerAudio === null ? "IconMicOn" : "IconMicOff";
    },
    camIcon() {
      return this.partnerVideo || this.partnerVideo === null ? "IconCamOn" : "IconCamOff";
    },
  },
};
</script>

<style scoped>
.videoControls {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 2px;
}
.userIsMuted {
  height: 20px;
  width: 20px;
  padding: 6px;
  border-radius: 360px;
  margin-right: 5px;
}
.cam {
  height: 17px;
  width: 17px;
  padding: 7.5px;
}
</style>
